// 统一请求路径前缀在commmon/axios.js中修改
import { postDemo, getRequestDemo, getDemo, deleDemo, deleDemos, getRequest, postRequest, postRequestLogin, putRequest, putNoToken, getRequestWithNoToken, } from '../assets/js/api';

// 我的成长值栏目下的api

/**
 * 成长曲线
 * @param {*parentId } string 家长id required
 * @param {*dateType } integer 日期类型 1、日2、月
 * @param {*endTime } string 结束时间,日期类型为月，表达式为yyyy-mm,日期类型为日，表达式为yyyy-mm-dd
 * @param {*startTime } string 开始时间,日期类型为月，表达式为yyyy-mm,日期类型为日，表达式为yyyy-mm-dd
 */
export const _getGorwthLine = (params) => {
  return postDemo('/api-customer-c/questionnaire/grow/gorwth', params)
}

/**
 * 我的成长值---问券概览
 * @param {*parentId } string 家长id required
 */
export const _questionPaper = (params) => {
  return getRequestDemo(`/api-customer-c/questionnaire/grow/overView/${params}`)
}

/**
 * 我的成长值---您的总体学习情况 曲线图
 * @param {*endTime } string 统计结束时间
 * @param {*startTime } string 统计开始时间
 * @param {*type } integer 统计类型,1_次数,2_时长
 * @param {*userId } string 用户id
 */
export const _allStudyStatus = (params) => {
  return getRequestDemo('/api-content/api/v1/content/manager/overall', params)
}

/**
 * 我的成长值_学习情况饼图
 * @param {*endTime } string 统计结束时间
 * @param {*startTime } string 统计开始时间
 * @param {*type } integer 统计类型,1_学习情况,2_学习偏好
 * @param {*userId } string 用户id
 */
export const _studyStatusPie = (params) => {
  return getRequestDemo('/api-content/api/v1/content/manager/pie', params)
}

/**
 * 我的成长值_我的成长值_学习情况雷达图
  * @param {*docType } string 统计类型,1_视频,2_文章
 * @param {*endTime } string 统计结束时间
 * @param {*startTime } string 统计开始时间
 * @param {*type } integer 统计类型,1_学习情况,2_学习偏好
 * @param {*userId } string 用户id
 */
export const _studyStatusRadar = (params) => {
  return getRequestDemo('/api-content/api/v1/content/manager/radar', params)
}

/**
 * 我的成长值_记录次数 [记录素材阅读次数dto]
  * @param {*contentId } string 视频文章的主键id
 * @param {*day } string 阅读日期  example: 2021-08-25T00:00:00.000+00:00
 * @param {*seconds } integer 
 * @param {*userId } string 用户id
 */
export const _recordTimes = (params) => {
  return postRequest('/api-content/api/v1/content/manager/recordTimes', params)
}


